// 在线评估-首页
<template>
  <div class="est-page">
    <div class="top-line">
      <el-button :type="showMainLeft ? '' : 'primary'" size="medium" class="btn-icon-36 btn-icon-36-menu" :class="{'btn-icon-1a3975': !showMainLeft}" icon="el-icon-notebook-2" @click="showMainLeft = !showMainLeft"></el-button>
      <div class="page-title">{{ this.activeHomePageTitle }}</div>
      <el-button class="btn-icon-36 btn-icon-36-prev btn-icon-1a3975" type="primary" size="medium" icon="el-icon-caret-left" @click="goPrevStep()"></el-button>
      <el-button class="btn-icon-36 btn-icon-36-next btn-icon-1a3975" type="primary" size="medium" icon="el-icon-caret-right" @click="goNextStep()"></el-button>
    </div>
    <div class="menu-list" v-show="showMainLeft">
      <div class="m-l-tab" v-for="(item) in activeMenuList" :key="item.id">
        <!-- <div class="m-l-tab-label tab-hover" :class="{'tab-clicked': menuTabId === item.id}" @click="menuTabClicked(item.id)">{{ item.content }}</div> -->
        <div class="m-l-SubTab" v-for="(subItem) in item.children" :key="subItem.id">
          <div class="m-l-SubTab-label tab-hover" :class="{'tab-clicked': activeHomePage === subItem.index}" v-if="menuTabId === item.id && subItem.showFlag" @click="menuSubTabClicked(subItem)">{{ subItem.content }}</div>
        </div>
      </div>
    </div>
    <!-- <div class="main">
      <iframe :src="iframeSrc" height="100%" width="100%" scrolling="no" frameborder="0"></iframe>
    </div>-->
    <div class="main-box">
      <estOverview v-if="activeHomePage==='/estOverview'" @doChangePath="doChangePath"></estOverview>
      <estEia v-if="activeHomePage==='/estEia'" @doChangePath="doChangePath"></estEia>
      <estAllocation v-if="activeHomePage==='/estAllocation'" @doChangePath="doChangePath"></estAllocation>
      <estMeeNotice v-if="activeHomePage==='/estMeeNotice'" @doChangePath="doChangePath"></estMeeNotice>
      <estExaApp v-if="activeHomePage==='/estExaApp'" @doChangePath="doChangePath"></estExaApp>
      <estEst v-if="activeHomePage==='/estEst'" @doChangePath="doChangePath"></estEst>
      <esTexamine v-if="activeHomePage==='/esTexamine'" @doChangePath="doChangePath"></esTexamine>
      <esTauthorize v-if="activeHomePage==='/esTauthorize'" @doChangePath="doChangePath"></esTauthorize>
      <estSave v-if="activeHomePage==='/estSave'" @doChangePath="doChangePath"></estSave>
    </div>
  </div>
</template>

<script>
// import api from '../../../api/indexForCoe'
import estOverview from '../coe-com/estOverview'
import estEia from '../coe-com/estEia'
import estAllocation from '../coe-com/estAllocation'
import estMeeNotice from '../coe-com/estMeeNotice'
import estExaApp from '../coe-com/estExaApp'
import estEst from '../coe-com/estEst'
import esTexamine from '../coe-com/esTexamine'
import esTauthorize from '../coe-com/esTauthorize'
import estSave from '../coe-com/estSave'
export default {
  props: ['showPageFP', 'estActiveStepLabelP', 'estActiveStepPathP', 'activeMenuListP', 'activeHomePageP'],
  data () {
    return {
      unreadableTips: '您没有进入该页面的权限，请联系管理员处理。开启权限后，重启应用即可进入。',
      onShowPageType: '在线评估',
      phone: '',
      userName: '',
      activeHomePage: this.activeHomePageP,
      activeHomePageTitle: '',
      estActiveStepLabel: this.estActiveStepLabelP,
      estActiveStepPath: this.estActiveStepPathP,
      activeMenuList: this.activeMenuListP,
      showMainLeft: false,
      menuTabId: 6,
      menuSubTabId: 1,
      iframeSrc: ''
    }
  },
  watch: {
    showPageFP (nv, ov) {
      console.log('showPageFP', nv, ov)
      this.getCrtPageTitle()
    }
  },
  mounted () {
    console.log('mounted', this.activeHomePage, this.activeMenuList, this.estActiveStepLabel, this.estActiveStepPath)
    console.log('showPageFP', this.showPageFP)
    this.getCrtPageTitle()
  },
  methods: {
    // coe
    getCrtPageTitle () {
      this.activeHomePageTitle = this.estActiveStepLabel[this.estActiveStepPath.indexOf(this.activeHomePage)]
      console.log('activeHomePage', this.activeHomePage, this.activeHomePageTitle, this.showPageFP, this.estActiveStepPath.indexOf(this.activeHomePage))
    },
    menuTabClicked (id) {
      this.menuTabId = this.menuTabId === id ? 0 : id
    },
    menuSubTabClicked (item) {
      this.menuSubTabId = item.id
      this.activeHomePage = item.index
      this.activeHomePageTitle = item.content
      this.showMainLeft = false
      console.log(item.index) // 路由
      // this.iframeSrc = item.index
    },
    doChangePath (path) {
      if (this.activeHomePage !== path) {
        this.activeHomePage = path
        this.activeHomePageTitle = this.estActiveStepLabel[this.estActiveStepPath.indexOf(this.activeHomePage)]
      }
    },
    goPrevStep () {
      console.log('activeHomePage', this.activeHomePage)
      var crtStepIndex = this.estActiveStepPath.indexOf(this.activeHomePage)
      var changedStepPath = this.estActiveStepPath[crtStepIndex - 1]
      if (changedStepPath) {
        this.doChangePath(changedStepPath)
      } else {
        this.$toast.text('没有更多可查看的页面了')
      }
    },
    goNextStep () {
      console.log('activeHomePage', this.activeHomePage)
      var crtStepIndex = this.estActiveStepPath.indexOf(this.activeHomePage)
      var changedStepPath = this.estActiveStepPath[crtStepIndex + 1]
      if (changedStepPath) {
        this.doChangePath(changedStepPath)
      } else {
        this.$toast.text('没有更多可查看的页面了')
      }
    }
  },
  components: {
    estOverview,
    estEia,
    estAllocation,
    estMeeNotice,
    estExaApp,
    estEst,
    esTexamine,
    esTauthorize,
    estSave
  }
}
</script>

<style lang="scss">
.est-page {
  width: 100%;
  height: 100%;
  background: #fff;
  .btn-icon-36 {
    font-size: 18px;
    width: 36px!important;
    height: 36px!important;
    padding: 8px!important;
    margin: 0 0 0 10px!important;
  }
  .btn-icon-1a3975 {
    border: #1a3975 1px solid;
    background-color: #1a3975!important;
  }
  .btn-icon-082567 {
    border: #082567 1px solid;
    background-color: #082567!important;
  }
  .btn-icon-1ab394 {
    border: #1ab394 1px solid;
    background-color: #1ab394!important;
  }
  .btn-icon-ed5565 {
    border: #ed5565 1px solid;
    background-color: #ed5565!important;
  }
  .btn-icon-23c6c8 {
    border: #23c6c8 1px solid;
    background-color: #23c6c8!important;
  }
  .img-icon-save, .img-icon-save:hover, .img-icon-save:focus {
    color: rgba(0, 0, 0, 0);
    // padding: 8px 5px!important;
    background: no-repeat;
    background-color: #409EFF;
    background-image: url('../../assets/coeicons/保存.png');
    background-position: 50% 50%;
    background-size: 60%;
    font-size: 18px!important;
    // border-radius: 4px 0 0 4px;
  }
  .img-icon-log, .img-icon-log:hover, .img-icon-log:focus {
    color: rgba(0, 0, 0, 0);
    // padding: 8px 5px!important;
    background: no-repeat;
    background-color: #409EFF;
    background-image: url('../../assets/coeicons/进度条.png');
    background-position: 50% 50%;
    background-size: 80%;
    // border-radius: 4px 0 0 4px;
  }
  .img-icon-new, .img-icon-new:hover, .img-icon-new:focus {
    width: 36px!important;
    color: rgba(0, 0, 0, 0);
    // padding: 8px 5px!important;
    background: no-repeat;
    // background-color: #409EFF;
    background-image: url('../../assets/coeicons/sms-new-1ab394.png');
    background-position: 50% 50%;
    background-size: 100%;
    border: 0;
    // border-radius: 4px 0 0 4px;
  }
  .btn-text {
    width: 84px;
    text-align: 14px;
    padding: 8px;
  }
  .top-line {
    background: #082567;
    height: 56px;
    .page-title {
      font-family: "Microsoft Yahei","Hiragino Sans GB","Helvetica Neue",Helvetica,tahoma,arial,"WenQuanYi Micro Hei",Verdana,sans-serif;
      height: 100%;
      font-size: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: bold;
      color: #cee8f0;
    }
    .btn-icon-36-menu {
      position: absolute;
      // left: 10px;
      top: 10px;
      z-index: 99;
    }
    .btn-icon-36-prev {
      position: absolute;
      right: calc(10px + 36px);
      top: 10px;
      z-index: 99;
      border-radius: 4px 0 0 4px!important;
    }
    .btn-icon-36-next {
      position: absolute;
      right: 10px;
      top: 10px;
      z-index: 99;
      border-radius: 0 4px 4px 0!important;
    }
  }
  .menu-list {
    position: absolute;
    top: 56px;
    // width: 240px;
    width: 100%;
    // height: 100%;
    overflow: auto;
    text-align: center;
    // .scrolling-element-inside {
    //   direction: ltr;
    // }
    .m-l-tab {
      width: 100%;
      background: #1a3975;
      // direction: ltr;
      color: #cee8f0;
      .tab-clicked {
        background-color: #082567;
      }
      .tab-hover:hover {
        background-color: #1a3975;
      }
      .m-l-tab-label {
        height: 40px;
        padding: 10px 10px;
        border-top: 2px solid #1a3975;
        line-height: 40px;
        font-size: 20px;
        font-weight: bold;
      }
      .m-l-SubTab {
        width: 100%;
        background: #1a3975;
        .m-l-SubTab-label {
          padding: 10px 10px;
          height: 20px;
          line-height: 20px;
          font-size: 16px;
          font-weight: bold;
          border-top: 1px solid #1a3975;
        }
      }
    }
  }
  .main-box {
    width: 100%;
    height: calc(100% - 56px);
    overflow-y: auto;
  }
  .prosit-main-box {
    width: 100%;
    // width: calc(100% - 2 * 8px);
    height: calc(100% - 56px);
    overflow-y: auto;
    .prosit-main-scroll-box {
      width: calc(100% - 2 * 8px);
      // width: 100%;
      // height: 100%;
      padding: 0 8px 4px;
      .step-title {
        width: 100%;
        height: 32px;
        line-height: 32px;
        text-align: center;
        // background-color: #f3f4f5;
        border-top: 2px solid #f3f4f5;
        // border-bottom: 2px solid #f3f4f5;
        margin-top: 4px;
      }
      .line-filelist {
        min-height: 32px;
      }
      .line-textarea {}
      .line-single {
        height: 32px;
      }
      .line-button {
        height: 36px;
        // padding-bottom: 8px!important;
        justify-content: center;
        // border-bottom: 2px solid #f3f4f5;
        .center-btn {
          margin: 0 8px!important;
        }
        .text-btn {
          font-size: 14px;
        }
      }
      .line-input {
        width: 100%;
        display: flex;
        padding: 4px 0;
        font-family: "Microsoft Yahei","Hiragino Sans GB","Helvetica Neue",Helvetica,tahoma,arial,"WenQuanYi Micro Hei",Verdana,sans-serif!important;
        .el-input__inner {
          height: 32px!important;
          padding: 0 4px;
          color: #000!important;
        }
        .el-textarea__inner {
          height: 72px!important;
          padding: 4px 4px;
          color: #000!important;
        }
        select {
          border-color: #DCDFE6;
          color: #000!important;
        }
        .label-full {
          width: 100%;
          min-height: 32px;
          font-size: 14px;
          // line-height: 32px;
          text-align: center;
          // margin-right: 4px;
        }
        .input-full {
          width: 100%;
        }
        .label-4 {
          width: 56px;
          font-size: 14px;
          line-height: 32px;
          text-align: right;
          margin-right: 4px;
        }
        .label-4l2 {
          width: 56px;
          font-size: 14px;
          line-height: 16px;
          text-align: right;
          margin-right: 4px;
        }
        .input-s4 {
          width: calc(100% - 60px);
        }
        .input-s4d2 {
          width: calc((100% - 60px) / 2);
        }
        .label-5 {
          width: 70px;
          font-size: 14px;
          line-height: 32px;
          text-align: right;
          margin-right: 4px;
        }
        .label-5l2 {
          width: 70px;
          font-size: 14px;
          line-height: 16px;
          text-align: right;
          margin-right: 4px;
        }
        .input-s5 {
          width: calc(100% - 74px);
        }
        .input-s5d2 {
          width: calc((100% - 74px) / 2);
        }
        .label-6 {
          width: 84px;
          font-size: 14px;
          line-height: 32px;
          text-align: right;
          margin-right: 4px;
        }
        .label-6l2 {
          width: 84px;
          font-size: 14px;
          line-height: 16px;
          text-align: right;
          margin-right: 4px;
        }
        .input-s6 {
          width: calc(100% - 88px);
        }
        .input-s6d2 {
          width: calc((100% - 88px) / 2);
        }
        .fileListDiv {
          max-height: 160px;
          width: calc(100% - 88px - 8px);
          overflow-y: auto;
          padding: 2px 4px;
          border: 1px solid #DCDFE6;
          border-radius: 2px;
          .fileItem {
            // height: 24px;
            line-height: 28px;
            vertical-align: middle;
            font-size: 14px;
            color: #00C;
          }
        }
      }
    }
  }
}
</style>
